import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  GeckoModal,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
  GECKO_UTILS,
} from 'ui';
import { useSelector, useDispatch } from 'react-redux';
import GeckoLocation from 'services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import Loader from 'components/Loader';
import {
  newIntegration,
  updateIntegration,
} from '../../../actions/integrations';

import { getLoggedInUser } from '../../../selectors/app_state';

const SlackSetupModal = (props) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(getLoggedInUser);

  const [values, setValues] = useState(props.values);
  const [loading, setLoading] = useState(false);

  const fields = [
    {
      key: 'name',
      label: 'Slack Webhook name',
      description: 'This is a name to identify this webhook',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
    },
    {
      key: 'url',
      label: 'Slack Webhook URL',
      description:
        'This can be found in the Slack Apps Management page on Slacks website',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
    },
  ];

  const onUserInput = (key, value) => {
    const newValue = GECKO_UTILS.setNestedValue(values, key, value);
    setValues(newValue);
  };

  const handleSubmit = () => {
    const validateRequired = (fields, values) => {
      return fields.reduce((valid, field) => {
        if (field.required && !GECKO_UTILS.getNestedValue(values, field.key)) {
          new GeckoToastService().error(`The ${field.label} field is required`);
          return false;
        }
        return valid;
      }, true);
    };
    const valid = validateRequired(fields, values);
    if (!valid) {
      return;
    }

    const slackIntegration = {
      type: 'slack',
      id: values.id,
      name: values.name,
      configuration: {
        url: values.url,
      },
      account_id: currentUser.account_id,
    };

    setLoading(true);
    return GeckoRequest.post('/integration/webhook', slackIntegration)
      .then((integration) => {
        if (integration.id) {
          props.values
            ? dispatch(updateIntegration(integration))
            : dispatch(newIntegration(integration));
          GeckoLocation.goTo(`/settings/integration/webhooks/slack`);
          new GeckoToastService().success('Slack Integration created');
          return new GeckoModalService().close();
        } else {
          new GeckoToastService().error(integration.error);
        }
      })
      .catch(renderError)
      .finally(() => setLoading(false));
  };

  const footerButtons = [
    {
      name: 'Done',
      type: 'primary',
      icon: 'far fa-check',
      handler: handleSubmit,
    },
  ];

  return (
    <Loader isLoading={loading}>
      <GeckoModal
        name="Please enter your Slack Webhook URL"
        fields={fields}
        values={values}
        btns={footerButtons}
        handler={onUserInput}
      />
    </Loader>
  );
};

SlackSetupModal.propTypes = {
  values: PropTypes.object,
};

export default SlackSetupModal;
